import { AuthApi } from '@repo/api'
import * as Sentry from '@sentry/react'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

function useUser() {
  const {
    data: user,
    isPending,
    error,
  } = useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      return await AuthApi.me()
    },
  })

  useEffect(() => {
    if (user?.id) {
      Sentry.setUser({
        id: String(user.id),
        organizationId: user.organizationId,
      })
      Sentry.setTag(
        'organizationId',
        user.organizationId !== null ? String(user.organizationId) : 'none',
      )
    } else {
      Sentry.setUser(null)
      Sentry.setTag('organizationId', undefined)
    }
  }, [user?.id, user?.organizationId])

  return {
    user,
    isPending,
    isError: !!error,
  }
}

export default useUser
